import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import FormInput from '../../components/elements/form_input';
import Button from '../../components/elements/button';
import { Mail, Eye, EyeOff, Lab } from '../../assets/icons';
import psw from '../../assets/icons/password.svg';
import '../../assets/css/lab/login.css';

const LabLogin = () => {
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            // Handle lab authentication
            navigate('/lab/dashboard');
        } catch (err) {
            setError('Invalid credentials');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="lab-login">
            <div className="login-container">
                <div className="login-visual">
                    <div className="visual-content">
                        <img src={Lab} alt="" className="lab-icon" />
                        <h2>Lab Portal</h2>
                        <p>Access your laboratory dashboard to manage test reports and analysis</p>
                    </div>
                </div>

                <div className="login-form-section">
                    <div className="form-header">
                        <img src="/logo.png" alt="eAquaHealth" className="logo" />
                        <h1>Laboratory Login</h1>
                        <p>Enter your credentials to access your account</p>
                    </div>

                    {error && (
                        <div className="error-message">
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="login-form">
                        <FormInput
                            label="Email Address"
                            type="email"
                            showLabel
                            value={formData.email}
                            onChange={(e) => setFormData({...formData, email: e.target.value})}
                            required
                            icon={<img src={Mail} alt="" />}
                            placeholder="lab@example.com"
                        />

                        <div className="password-input">
                            <FormInput
                                label="Password"
                                showLabel
                                type={showPassword ? 'text' : 'password'}
                                value={formData.password}
                                onChange={(e) => setFormData({...formData, password: e.target.value})}
                                required
                                icon={<img src={psw} alt="" />}
                                placeholder="Enter your password"
                            />
                            <button 
                                type="button"
                                className="toggle-password"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <img src={EyeOff} alt="" /> : <img src={Eye} alt="" />}
                            </button>
                        </div>

                        <div className="form-options">
                            <label className="remember-me">
                                <input type="checkbox" />
                                <span>Remember me</span>
                            </label>
                            <Link to="/lab/reset-password" className="forgot-password">
                                Forgot Password?
                            </Link>
                        </div>

                        <Button
                            text={isLoading ? "Logging in..." : "Login"}
                            type="submit"
                            variant="primary"
                            fullWidth
                            loading={isLoading}
                            disabled={isLoading}
                        />
                    </form>

                    <div className="help-section">
                        <p>Need help? <Link to="/support">Contact Support</Link></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LabLogin;